import React from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { useDebouncedCallback } from "use-debounce";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { HTMLConstants, InvoiceConstants } from "utils/constants";
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
import { QuotationTemplatePreviewProps } from "models/propTypes/quotationPropTypes";
//#endregion
//#region components
import { FileViewerContainer } from "components/common";
import { Portal } from "@mui/material";
import { useQuotesService } from "serviceHooks";
//#endregion

const QuotationTemplatePreview: React.FC<QuotationTemplatePreviewProps> = (props) => {
  const quotesService = useQuotesService();
  const { values, quotation } = props;

  const invoiceTemplateMount = document.getElementById(HTMLConstants.EntityCreationLayoutLowerLeftPortalId);

  const [fileMeta, setFileMeta] = React.useState<ImageMeta[]>();

  const loadQuotationTemplate = useDebouncedCallback((values: InvoiceFormTypes.Create) => {
    const quotationPost: WintSuperkollAPIModel.QuotationPost = quotesService.convertFormToAPIRequest(
      values,
      quotation?.serialNumber
    );

    quotesService.generateQuotationPreview(quotationPost).then((res) => {
      const htmlContent = res.data as unknown as string;
      setFileMeta(
        htmlContent
          ? [
              {
                id: 0,
                contentType: "html",
                numberOfPages: 1,
                data: htmlContent,
              },
            ]
          : undefined
      );
    });
  }, InvoiceConstants.DebounceDelay);

  React.useEffect(() => {
    loadQuotationTemplate(values);
  }, [values]);

  return (
    <Portal container={invoiceTemplateMount}>
      <FileViewerContainer meta={fileMeta} parentId={0} preventDownload />
    </Portal>
  );
};

export default QuotationTemplatePreview;
